import {
  DeviceEntity,
} from './deviceEntity';
import { CreateDatetime } from './valueObjects/createDatetime';
import { ParentId } from './valueObjects/parentId';

import type {
  DeviceProps,
} from './deviceEntity';
import type { DeviceJson } from '@/types/domain/device/entities/deviceEntity';

import { Factory } from '@/domain/factory';

export class DeviceFactory extends Factory<
  DeviceEntity,
  DeviceProps,
  DeviceJson
> {
  comparePvt = (a: DeviceJson, b: DeviceJson) => a.parentId.localeCompare(b.parentId, 'en');

  createPvt(props: DeviceProps): DeviceEntity {
    return new DeviceEntity(props, null);
  }

  createFromJsonPvt(props: DeviceJson): DeviceEntity {
    return this.createPvt({
      parentId: ParentId.create(props.parentId),
      createDatetime: CreateDatetime.create(new Date(props.createDatetime)),
      token: props.token,
    });
  }
}
